import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CollectionModel } from './models/collection.model';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { BookmarkModel } from '../bookmarks/models/bookmark.model';
import { BookmarksService } from '../bookmarks/bookmarks.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bookmarks/bookmarks.service";
/**
 * Collections service endpoint
 */
var collectionsURL = '/ws/enterprise/collection';
var OrganizationsService = /** @class */ (function () {
    function OrganizationsService(http, bookmarkService) {
        this.http = http;
        this.bookmarkService = bookmarkService;
    }
    OrganizationsService.prototype.getCollections = function (groupId) {
        var _this = this;
        return this.http.get(collectionsURL + "?group_id=" + groupId)
            .pipe(map(function (results) {
            return plainToClass(CollectionModel, results)
                .map(function (collection) { return _this.normalizeCollectionModel(collection); });
        }));
    };
    OrganizationsService.prototype.getCollectionsByContent = function (groupId, content, includeContent) {
        var _this = this;
        if (includeContent === void 0) { includeContent = false; }
        var content_type = content.content_type, content_id = content.content_id;
        var url = collectionsURL + "?group_id=" + groupId + "&content_type=" + content_type + "&content_id=" + content_id + "&include_content=" + (includeContent ? 1 : 0);
        return this.http.get(url)
            .pipe(map(function (results) {
            return plainToClass(CollectionModel, results)
                .map(function (collection) { return _this.normalizeCollectionModel(collection); });
        }));
    };
    /**
     * Gets the collection content id by content
     */
    OrganizationsService.prototype.getCollectionContentId = function (collection, content) {
        var content_type = content.content_type, content_id = content.content_id;
        return this.getCollectionsByContent(collection.group_id, content, true)
            .pipe(
        // restrict to target collection
        map(function (collections) { return collections.find(function (c) { return c.collection_id === collection.collection_id; }); }), map(function (c) {
            var foundBookmark;
            if (c) {
                foundBookmark = c.collection_content.find(function (bookmark) {
                    return content_type === 'module' ? content_id === bookmark.module_name : content_id === bookmark.id;
                });
            }
            return foundBookmark ? foundBookmark.collection_content_id : null;
        }));
    };
    /**
     * Gets an individual group collection.
     */
    OrganizationsService.prototype.getCollection = function (groupId, collectionId, includeContent) {
        var _this = this;
        return this.http.get(collectionsURL + "?group_id=" + groupId + "&collection_id=" + collectionId + "&include_content=" + (includeContent ? 1 : 0))
            .pipe(map(function (collections) {
            var collection = collections[0];
            return collection ? _this.normalizeCollectionModel(collection) : collection;
        }));
    };
    /**
     * Gets the list of models in the specified collection.
     */
    OrganizationsService.prototype.getCollectionContent = function (groupId, collectionId, query) {
        if (query === void 0) { query = ''; }
        var queryParts = query.toLocaleLowerCase().split(' ');
        return this.getCollection(groupId, collectionId, true)
            .pipe(map(function (result) {
            // exclude unavailable
            return result.collection_content
                .map(function (bookmark) { return plainToClass(BookmarkModel, bookmark); })
                .filter(function (bookmark) {
                var include = true;
                if (queryParts.length && bookmark.title) {
                    queryParts.forEach(function (queryPart) {
                        include = include && bookmark.title.toLocaleLowerCase().indexOf(queryPart) >= 0;
                    });
                }
                include = include && bookmark.unavailable !== true;
                return include;
            });
        }));
    };
    OrganizationsService.prototype.addToCollection = function (collection, models) {
        var _this = this;
        return this.formPost(collectionsURL, {
            group_id: collection.group_id,
            collection_id: collection.collection_id,
            add_content: models
        })
            .pipe(map(function (_collections) {
            return _collections.map(function (_collection) { return _this.normalizeCollectionModel(_collection); });
        }));
    };
    OrganizationsService.prototype.removeFromCollection = function (collection, collectionContentIds) {
        var _this = this;
        return this.formPost(collectionsURL, {
            group_id: collection.group_id,
            collection_id: collection.collection_id,
            remove_content: collectionContentIds
        })
            .pipe(map(function (_collections) {
            return _collections.map(function (_collection) { return _this.normalizeCollectionModel(_collection); });
        }));
    };
    OrganizationsService.prototype.getOrganizationAttribute = function (attributes, type, name) {
        return attributes.find(function (attribute) { return attribute.type === type && attribute.name === name; });
    };
    /**
     * Adds the current user to the specified organization (by organization's eid)
     */
    OrganizationsService.prototype.addUserToOrganization = function (group_eid) {
        return this.http.post("/ws/enterprise/user/add", { 'group_eid': group_eid });
    };
    OrganizationsService.prototype.addUserWithGroupCode = function (group_code) {
        return this.http.post("/ws/enterprise/user/add", { 'group_code': group_code });
    };
    OrganizationsService.prototype.normalizeCollectionModel = function (collection) {
        var _this = this;
        if (collection.collection_content) {
            collection.collection_content.forEach(function (bookmark) {
                _this.bookmarkService.normalizeBookmarkModel(bookmark);
            });
        }
        return collection;
    };
    // TODO: centralize form posting logic or migrate service to accept JSON
    OrganizationsService.prototype.formPost = function (url, payload) {
        var formHeaders = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
        var body = new URLSearchParams();
        Object.keys(payload).forEach(function (key) {
            var value = payload[key];
            var encodedValue = "" + (value instanceof Object ? JSON.stringify(value) : value);
            body.set(key, encodedValue);
        });
        return this.http.post("" + url, body.toString(), formHeaders)
            .pipe(map(function (reponse) { return reponse; }));
    };
    OrganizationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrganizationsService_Factory() { return new OrganizationsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BookmarksService)); }, token: OrganizationsService, providedIn: "root" });
    return OrganizationsService;
}());
export { OrganizationsService };
